<template>
    <div class="md:max-w-[377px] h-fit min-h-[316px] md:min-h-[370px] flex-col xl:max-w-[328px]">
        <MiscIcon
            class="w-[88px] h-auto text-new" 
            :name="'review'"
        />
        <div v-if="getConfig?.title?.value" class="font-semibold text-xl text-link pt-4">
            {{ getConfig?.title?.value }}
        </div>

        <div class="h-full flex flex-col text-lg">
            <div v-if="getConfig?.text?.value" class="prose max-w-none prose-headings:text-link prose-headings:font-semibold pt-4" v-html="getConfig?.text?.value" />

            <div v-if="getConfig?.name?.value" class="pt-4 font-semibold">
                {{ getConfig?.name?.value }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'
import { computed } from "vue";

const props = defineProps<{
    config: HblSlot
}>()

const getConfig = computed(() => {
    return props?.config?.config
})
</script>